function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
const baseUrl = '/companies';
class PartnerClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAllPartnerCompanies", async (partnerType)=>this.get(`${baseUrl}?companyType=${partnerType || 'PARTNER'}`)), _define_property(this, "getPartnerCompany", async (companyId)=>this.get(`${baseUrl}/${companyId}`)), _define_property(this, "createPartnerCompany", async (payload)=>this.post(baseUrl, payload)), _define_property(this, "updatePartnerCompany", async (payload)=>this.put(`${baseUrl}/${payload.companyId}`, payload)), _define_property(this, "deletePartnerCompany", async (payload)=>this.delete(`${baseUrl}/${payload.companyId}`)), _define_property(this, "getAllPartnerPermissions", async ()=>this.get('/permission-set/partner')), _define_property(this, "getAllUserInPartnerCompany", async (companyId)=>this.get(`${baseUrl}/${companyId}/users`));
    }
}
export const PartnerAPI = new PartnerClient();
